/*
Validate standard zip code like 00501
@zipcode : Zip code to test
*/
const validateZipCode = function (zipcode) {
    // examples :re.text(00501)
    const re = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
    return re.test(zipcode);
};
export default validateZipCode;
